import { INSERT_CHECK_LIST_COMMAND, INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND } from '@lexical/list';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { CheckBoxOutlinedIcon, FormatListBulletedIcon, FormatListNumberedIcon } from '@medly-components/icons';
import { FC } from 'react';

import { BlockType, FormatListButtonsProps } from './types';

export const FormatListButtons: FC<FormatListButtonsProps> = ({ blockType, isEditable, onBlockTypeChange }) => {
    const [editor] = useLexicalComposerContext();
    const formatList = (listType: BlockType) => {
        if (listType === 'number' && blockType !== 'number') {
            editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined);
            onBlockTypeChange('number');
        } else if (listType === 'bullet' && blockType !== 'bullet') {
            editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);
            onBlockTypeChange('bullet');
        } else if (listType === 'check' && blockType !== 'check') {
            editor.dispatchCommand(INSERT_CHECK_LIST_COMMAND, undefined);
            onBlockTypeChange('check');
        } else {
            editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
            onBlockTypeChange('paragraph');
        }
    };

    return (
        <>
            <button
                type="button"
                disabled={!isEditable}
                onClick={() => formatList('bullet')}
                className={`toolbar-item spaced ${blockType === 'bullet' ? 'active' : ''}`}
                aria-label="Format text with adding a bullet list"
            >
                <FormatListBulletedIcon />
            </button>
            <button
                type="button"
                disabled={!isEditable}
                onClick={() => formatList('number')}
                className={`toolbar-item spaced ${blockType === 'number' ? 'active' : ''}`}
                aria-label="Format text with adding a numbered list"
            >
                <FormatListNumberedIcon />
            </button>
            <button
                type="button"
                disabled={!isEditable}
                onClick={() => formatList('check')}
                className={`toolbar-item spaced ${blockType === 'check' ? 'active' : ''}`}
                aria-label="Format text with adding a check list"
            >
                <CheckBoxOutlinedIcon />
            </button>
        </>
    );
};
